import { UtilitiesService } from "../actions/@base/services";
import { CSS_SIZE_UNIT_PX } from "../../external/models";
import { CdkDragMove } from "@angular/cdk/drag-drop";

interface Point {
  x: number,
  y: number,
}

export class DrawerTextUtil {

  public static calculatePosition(event: CdkDragMove, dragContainerRect: DOMRect, parentRect: DOMRect): Point {
    const { x: pointerPositionX, y: pointerPositionY } = event.pointerPosition;
    const { top: elementTop, left: elementLeft } = dragContainerRect;
    const { left: wrapperLeft, top: wrapperTop } = parentRect;

    const fromLeftOfDraggedElement = pointerPositionX - elementLeft;
    const fromTopOfDraggedElement = pointerPositionY - elementTop;

    const x = Math.abs(pointerPositionX - fromLeftOfDraggedElement - wrapperLeft);
    const y = Math.abs(pointerPositionY - fromTopOfDraggedElement - wrapperTop);
    return { x, y };
  }

  public static standarizeXPosition(
    wrapperWidth: number,
    hostElement: HTMLElement,
    textInputElement: HTMLElement,
    currentXPosition: string
  ): string {
    return hostElement.offsetLeft >= wrapperWidth - textInputElement.offsetWidth
      ? `${ DrawerTextUtil.calcMaxPercentageOffsetX(wrapperWidth, textInputElement) }%`
      : currentXPosition;
  }

  public static standardizeYPosition(
    wrapperHeight: number,
    hostElement: HTMLElement,
    textInputElement: HTMLElement,
    currentYPosition: string
  ): string {
    return hostElement.offsetTop >= wrapperHeight - textInputElement.offsetHeight
      ? `${ DrawerTextUtil.calcMaxPercentageOffsetY(wrapperHeight, textInputElement) }%`
      : currentYPosition;
  }

  public static isAllowed(event: KeyboardEvent, maxLength: number): boolean {
    const target = event.target as HTMLInputElement;
    const inputElement = target.textContent ?? '';
    return Number(inputElement.length) < maxLength || event.key === 'Backspace';
  }

  public static handleGeometryChange(
    eventTargetRect: DOMRect,
    hostElement: HTMLElement,
    isBoxActive: boolean,
    utilitiesService: UtilitiesService
  ): void {
    const bottom = window.innerHeight - hostElement.offsetTop;
    const keyboard = eventTargetRect;

    const wrapper = hostElement.parentNode as any;

    if (isBoxActive && bottom < keyboard.height + hostElement.scrollHeight) {
      const top = utilitiesService.percentage(
        wrapper.offsetHeight - hostElement.scrollHeight - keyboard.height,
        wrapper.offsetHeight
      );

      hostElement.style.top = `${ top }%`;
    }
  }

  public static generateTooltipLeftPositionCSS(
    tooltipWidth: string,
    pinSize: string,
    wrapperLeft: number,
    dragContainerLeft: number
  ): string {
    return dragContainerLeft - +tooltipWidth <= wrapperLeft
      ? `calc(100% + ${ pinSize }${ CSS_SIZE_UNIT_PX })`
      : `-${ tooltipWidth }${ CSS_SIZE_UNIT_PX }`;
  }

  private static calcMaxPercentageOffsetX(wrapperWidth: number, textInputElement: HTMLElement): number {
    const maxAbsoluteOffsetX = wrapperWidth - textInputElement.offsetWidth - 1;
    return (maxAbsoluteOffsetX / wrapperWidth) * 100;
  }

  private static calcMaxPercentageOffsetY(wrapperHeight: number, textInputElement: HTMLElement): number {
    const maxAbsoluteOffsetY = wrapperHeight - textInputElement.offsetHeight - 1;
    return (maxAbsoluteOffsetY / wrapperHeight) * 100;
  }
}
